import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

/**
 * Renders admin-authored markdown (announcement explanations, release note
 * details) as React elements — `react-markdown` never emits raw HTML by
 * default, so this is safe without a sanitizer.
 *
 * No typography plugin in this app (not worth a new dependency for a
 * handful of call sites) — these descendant utilities cover what these
 * fields realistically carry: paragraphs, bold/italic, links, lists.
 */
export function MarkdownContent({ children, className }: { children: string; className?: string }) {
  return (
    <div
      className={cn(
        'space-y-3 text-sm leading-relaxed text-foreground [&_a]:text-accent-brand [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-5',
        className,
      )}
    >
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
